// extracted by mini-css-extract-plugin
export default {"wrapper":"AIInsight_wrapper__RRk1L","btn":"AIInsight_btn__a+GHw","betaTag":"AIInsight_betaTag__T5dAi"};